import { BackToTopButtonController } from "./back-to-top-button.controller";

angular
    .module("thor.shared.back-to-top-button.component", [])
    .component("thorBackToTopButton", {
        bindings: {
            backToTopTarget: "<"
        },
        controller: BackToTopButtonController,
        controllerAs: "backToTopCtrl",
        template: require("./back-to-top.html")
    });
